<template>
  <div class="bg">
    <!-- 搜索栏 -->
    <div class="top_search_part main_top_search">
      <div class="search_box">
        <div class="search_item">
          <el-input v-model="orderNum" :placeholder="$t('message.orderSearchPlaceholder')"></el-input>
        </div>
        <div class="search_item">
          <el-input v-model="orderSenderName" :placeholder="$t('message.orderSearchPlaceholder2')"></el-input>
        </div>
        <div class="search_item">
          <el-date-picker v-model="orderTime" type="datetimerange" range-separator=" - " :start-placeholder="$t('message.orderTimeStartHolder')" :end-placeholder="$t('message.orderTimeEndHolder')" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </div>
        <div class="search_item">
          <el-select v-model="orderStatus" :placeholder="$t('message.exportDatePlaceholder')" multiple collapse-tags>
            <el-option v-for="item in $t('message.orderStatusList')" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="search_item">
          <el-cascader :value="orderSelProvince" :options="orderProvince" @change="handleChange" :placeholder="$t('message.orderSearchPlaceholder3')" clearable :show-all-levels="false"></el-cascader>
        </div>
        <div class="search_item">
          <el-input v-model="orderRemark" :placeholder="$t('message.orderSearchPlaceholder4')"></el-input>
        </div>
        <div class="search_item">
          <el-input v-model="containerOrderNumber" :placeholder="$t('message.containerOrderNumber')"></el-input>
        </div>
        <div class="search_btn" @click="searchOrderNum">{{$t('message.searchBtnText')}}</div>
        <div class="search_btn" @click="exportOrders">{{$t('message.exportText')}}</div>
      </div>
    </div>
    <!-- 搜索栏 -->
    <!-- 列表 -->
    <!-- 订单管理列表 -->
    <div class="content">
      <div class="tableBox">
        <el-table id="orderList" :data="orderList" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" height="100%" @sort-change="sortChange">
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="85"></el-table-column>
          <el-table-column :label="$t('message.containerOrderNumber')" prop="containerCoding" min-width="210"></el-table-column>
          <el-table-column :label="$t('message.arrivePort')" prop="JZXCITY" min-width="100"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle1')" prop="ORDERNUM" min-width="210"></el-table-column>
          <el-table-column :label="$t('message.orderRemarkTitle')" prop="REMARK" width="150"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle2')" width="120">
            <template slot-scope="scope">
              <a :href="scope.row.imgSrc" :download="scope.row.TXM">
                <img class="barCodeImg" :src="scope.row.imgSrc" />
                <!-- <el-image class="barCodeImg" :src="scope.row.imgSrc" :preview-src-list="[scope.row.imgSrc]"></el-image> -->
              </a>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.orderTableTitle3')" width="100">
            <template slot-scope="scope">
              <div class="operate_btn_box">
                <el-button class="operation_a_blue" @click.native.prevent="checkLogistics(scope.row)">{{$t('message.orderTableCheckTitle')}}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.addresseeAddressTitle')" prop="SJDZ" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('message.addresseeCompanyTitle')" prop="SJGS" min-width="150"></el-table-column>
          <el-table-column :label="$t('message.addresseeNameTitle')" prop="SJR" width="140"></el-table-column>
          <el-table-column :label="$t('message.addresseePhoneTitle')" prop="SJRPHONE" width="150"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle10')" prop="status" width="120"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle11')" prop="addTime" min-width="120" sortable="custom"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle7')" prop="WPSL" width="130"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle8')" prop="WPZL" width="130"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle9')" prop="WPTJ" width="130"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle4')" prop="JJGS" min-width="150"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle5')" prop="JJR" width="140"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle6')" prop="JJRPHONE" width="150"></el-table-column>
          <el-table-column :label="$t('message.customTableTitle5')" width="130" fixed="right" >
            <template slot-scope="scope">
              <div class="operate_btn_box">
                <a target="_blank" :href="url + '/pdf/WlOrder?ORDERNUM=' + scope.row.ORDERNUM">pdf</a>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="page_no"
        :page-sizes="pageSizes"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next"
        :total="totalSize"
        class="tablePage">
      </el-pagination>
    </div>
    <!-- 列表 -->
  </div>
</template>

<script>
  import { getProvince, imgSrc, getOrderList, exportOrders, HTTPS } from '@/api/getData.js'
  export default {
    name: 'orderCheck',
    data () {
      return {
        page_no: 1,
        page_size: 10,
        pageSizes: [10, 20, 30, 50, 100],
        totalSize: 0,
        orderList: [],
        orderNum: '',
        orderSenderName: '',
        orderStatus: [0, 1, 2],
        orderTime: null,
        orderProvince: [], // 收件省份
        orderSelProvince: '', // 收件省份选择
        orderRemark: '',
        containerOrderNumber: '',
        prop: null, // 排序字段
        order: '', // 排序方式，desc,
        exportJson: {}
      }
    },
    created() {
      this.getProvince()
      let param = this.$store.state.JHSS_orderCheck_param
      if (param.PAGE) this.page_no = param.PAGE
      if (param.TYPE) this.page_size = param.TYPE
      if (param.ORDERNUM) this.orderNum = param.ORDERNUM
      if (param.JJR) this.orderSenderName = param.JJR
      if (param.UADDTIME && param.DADDTIME) this.orderTime = [param.UADDTIME, param.DADDTIME]
      if (param.STATE) this.orderStatus = param.STATE.split(',').map(item => { return parseInt(item) })
      if (param.CITY2) this.orderSelProvince = param.CITY2
      if (param.ORDERANDREMARK) this.orderRemark = param.ORDERANDREMARK
      if (param.JZXNUM) this.containerOrderNumber = param.JZXNUM
      // 查询订单列表
      this.getOrderList(param)
    },
    methods: {
      // 查询订单省份
      async getProvince () {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let res = await getProvince({})
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data)
        this.orderProvince = res.data.map(item => {
          item.value = item.PROVINCE2
          item.label = item.PROVINCE2
          item.children = item.children.map(child => {
            child.value = child.CITY2
            child.label = child.CITY2
            return child
          })
          return item
        })
      },
      handleChange (list) {
        this.orderSelProvince = list.length === 0 ? '' : list[1]
      },
      // 查询订单列表
      async getOrderList (param) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        param = param || {}
        param.USERID = this.$store.state.JHSS.personalUserid
        param.STATE = this.orderStatus.join(',')
        param.CITY2 = this.orderSelProvince
        if (this.prop) {
          param.ORDERNAME = this.prop
        }
        param.DOA = this.order
        param.PAGE = this.page_no
        param.TYPE = this.page_size
        let res = await getOrderList(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        this.exportJson = param
        // console.log(res.data.ds)
        this.totalSize = res.data.num
        let index = (this.page_no - 1) * this.page_size
        let orderState2 = this.$t('message.orderState2')
        let orderState1 = this.$t('message.orderState1')
        let orderState0 = this.$t('message.orderState0')
        let orderState3 = this.$t('message.orderState3')
        this.orderList = res.data.dt.map(item => {
          item.index = ++index
          item.imgSrc = imgSrc(item.TXM)
          item.containerCoding = !item.JZXNUM ? '' : (item.JZXNUM + '（' + item.JZXSIZE + '）')
          // item.status = item.STATE === '2' ? orderState2 : (item.STATE === '1' ? orderState1 : orderState0)
          switch (item.STATE) {
            case '0':
              item.status = orderState0
              break
            case '1':
              item.status = orderState1
              break
            case '2':
              item.status = orderState2
              break
            default:
              item.status = orderState3
          }
          item.addTime = item.ADDTIME.replace(/T/g, ' ')
          return item
        })
        this.$store.commit('setOrderCheckParam', param)
      },
      // 搜索订单编号
      searchOrderNum () {
        this.page_no = 1
        this.searchFun()
      },
      sizeChange (val) {
        // console.log(val)
        this.page_size = val
        this.page_no = 1
        this.searchFun()
      },
      currentChange (val) {
        // console.log(val)
        this.page_no = val
        this.searchFun()
      },
      searchFun () {
        let param = {}
        // 查询客户管理
        if (this.orderNum) {
          param.ORDERNUM = this.orderNum
        }
        if (this.orderSenderName) {
          param.JJR = this.orderSenderName
        }
        if (this.orderTime) {
          param.UADDTIME = this.orderTime[0]
          param.DADDTIME = this.orderTime[1]
        }
        if (this.orderRemark) param.ORDERANDREMARK = this.orderRemark
        if (this.containerOrderNumber) param.JZXNUM = this.containerOrderNumber
        this.getOrderList(param)
      },
      // 导出订单
      async exportOrders () {
        const message = this.$message({
          message: 'loading...',
          iconClass: 'el-icon-loading',
          duration: 0
        })
        let param = this.exportJson
        let res = await exportOrders(param)
        message.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else {
          // console.log(res.data)
          let str = HTTPS + "/xlsx/" + res.data
          window.open(str)
        }
      },
      // 查看物流
      checkLogistics (obj) {
        this.$router.push({ path: '/logisticsCheck', query: { orderNum: obj.ORDERNUM } })
      },
      // 时间排序
      sortChange (obj) {
        // console.log(obj)
        // 根据时间排序（prop: addTime ，order: 'ascending', 'descending', null）
        this.prop = null
        if (obj.prop === 'addTime') {
          this.prop = 'ADDTIME'
          // param.ORDERNAME = 'ADDTIME'
        }
        this.order = ''
        if (obj.order === 'descending') {
          this.order = 'DESC'
          // param.DOA = 'DESC'
        }
        // this.page_no = 1
        this.searchFun()
      }
    },
    computed: {
      url () {
        return HTTPS
      }
    }
  }
</script>

<style scoped>
.main_top_search {
  /* height: 180px; */
  height: 126px;
  flex-wrap: wrap;
}
.main_top_search :first-child {
  flex-wrap: wrap;
  flex-shrink: 1;
}
.main_top_search :first-child .search_item, .main_top_search :first-child .search_btn, .main_top_search :first-child .add_btn {
  /* margin-bottom: 10px; */
  margin-top: 10px;
}
</style>
